import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import { Component } from 'react';

import settings from '/@/core/settings';

import Input from '/@/v3/components/forms/input';
import Title from '/@/v3/components/title';
import styles from './styles.module.css';

@autobind
export default class BasicHeader extends Component {
    static propTypes = {
        className: PropTypes.string,
        title: PropTypes.string,
        searchPlaceholder: PropTypes.string,
        searchText: PropTypes.string,
        onChangeSearch: PropTypes.func,
    };

    render() {
        const { className, title, searchText, onChangeSearch, searchPlaceholder } = this.props;

        const enabledSearch = searchPlaceholder != undefined && searchText != undefined && onChangeSearch != undefined;

        return (
            <div className={className}>
                <Title theme={settings.app.theme} bolder className={styles.title} size='xl'>
                    {title}
                </Title>
                {enabledSearch && (
                    <div className={styles.search}>
                        <Input
                            color={settings.app.theme}
                            value={searchText}
                            onChange={onChangeSearch}
                            className={styles.search}
                            placeholder={searchPlaceholder}
                            prefix={<i className='material-icons'>search</i>}
                        />
                    </div>
                )}
            </div>
        );
    }
}
